module.exports = __webpack_public_path__ + "img/flekt.131e5e83.png";